// Libs
import React, { useEffect, useState } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Formik } from "formik";
import { yupValidationSchema } from "./validationSchema-yup";
import { useQueryParam, StringParam } from "use-query-params";

// Components
import SignUpForm from "./SignUpForm";

// Modules
import { getListingsCategory } from "../../module/shared/listingsCategory";
import { signUp, setLoginEmail } from "newDropshipperApp/module/signup";

const initialValues = {
  name: "",
  email: "",
  topCategories: ""
};

const SignUpFormContainer = ({
  signUp,
  setLoginEmail,
  getListingsCategory,
  listingsCategory
}) => {
  const email = useQueryParam("email", StringParam)[0];
  const [name, setName] = useState("");

  useEffect(() => {
    getListingsCategory();
    setLoginEmail(email); // If there is a email on the query string, save it on store
  }, []);

  useEffect(() => {
    if (email) {
      setName(email.split("@")[0]);
      setTimeout(
        () => document.querySelectorAll("#Signup__button-submit")[0].click(),
        1000
      );
    }
  },[email]);

  return (
    <Formik
      initialValues={{ ...initialValues, email, name, listingsCategory }}
      enableReinitialize
      validationSchema={yupValidationSchema}
      onSubmit={(values, actions) => signUp(values, actions)}
      render={SignUpForm}
    />
  );
};

function mapStateToProps(state) {
  return {
    listingsCategory: state.shared.listingsCategory.categories
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      signUp,
      setLoginEmail,
      getListingsCategory
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SignUpFormContainer);



// WEBPACK FOOTER //
// ./src/newDropshipperApp/pages/signup/SignUpFormContainer.js